var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"blockchain-list"},_vm._l((_vm.supportedWallets),function(supportedWallet){return _c('supportedWalletsItem',{key:supportedWallet.id,attrs:{"supportedWallet":supportedWallet}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }